var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 979,
    viewBox: "0 0 1920 979",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 979,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2057.5 181.5C2057.5 594.221 1413.83 1006 697.688 1006C-18.4529 1006 -550 457.422 -550 44.7015C-550 -368.019 -18.4529 -548.491 697.688 -548.491C1413.83 -548.491 2057.5 -231.221 2057.5 181.5Z",
    fill: "#07DE1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2057.5 181.5C2057.5 594.221 1413.83 1006 697.688 1006C-18.4529 1006 -550 457.422 -550 44.7015C-550 -368.019 -18.4529 -548.491 697.688 -548.491C1413.83 -548.491 2057.5 -231.221 2057.5 181.5Z",
    fill: "#064201",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2126 107.5C2126 520.221 1499.32 902 788.5 902C77.6811 902 -498.5 170.221 -498.5 -242.5C-498.5 -655.221 107.913 -613 818.731 -613C1529.55 -613 2126 -305.221 2126 107.5Z",
    fill: "#63E971"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2126 107.5C2126 520.221 1499.32 902 788.5 902C77.6811 902 -498.5 170.221 -498.5 -242.5C-498.5 -655.221 107.913 -613 818.731 -613C1529.55 -613 2126 -305.221 2126 107.5Z",
    fill: "#064201",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2164.5 95.9999C2164.5 473.894 1630.31 781.041 1001.69 781.041C373.074 781.041 -126.5 376.394 -126.5 -1.50012C-126.5 -379.394 373.074 -587.433 1001.69 -587.433C1630.31 -587.433 2164.5 -281.894 2164.5 95.9999Z",
    fill: "#82F38D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2164.5 95.9999C2164.5 473.894 1630.31 781.041 1001.69 781.041C373.074 781.041 -126.5 376.394 -126.5 -1.50012C-126.5 -379.394 373.074 -587.433 1001.69 -587.433C1630.31 -587.433 2164.5 -281.894 2164.5 95.9999Z",
    fill: "#064201",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 979,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorBg);
export default __webpack_public_path__ + "static/media/vector-bg.aaab083b5325d96544a461b98eb009a3.svg";
export { ForwardRef as ReactComponent };